import { useState, useEffect, useContext } from "react";
import axios from 'axios';
import Contact from "../views/Contact"
import Navbar from "../components/Navbar";
import About from "../views/About";
import Home from '../views/Home'
import Services from "../views/Services";
import Projects from "../views/Projects";
import LoadingScreen from "../components/LoadingScreen";
import { ThemeContext } from "../Contexts/themeProvider"
import ChatBot from "../LiveAi/ChatBot";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from 'react-router-dom'; 
import ChatButton from "../LiveAi/ChatButton";
import { devProjects } from "../Constant/common";

function All({chatOpen,setChatOpen,}) {
  const [loading, setLoading] = useState(true)
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode; 
  const location = useLocation();

  
  // const getPublicIP = async () => {
  //   try {
  //     const response = await axios.get('https://api.ipify.org?format=json');
  //     return response.data.ip;  // Extract IP address from response
  //   } catch (error) {
  //     console.error('Error fetching IP address:', error);
  //     return null;
  //   }
  // };

  // Function to log traffic
  // const logTraffic = async () => {
  //   const ipAddress = await getPublicIP();
  //   if (!ipAddress) {
  //     alert('Unable to fetch IP address');
  //     return;
  //   }

  //   const userAgent = navigator.userAgent;  // Get browser user-agent
  //   const route = '/about';  // Example route you're logging for
  //   const location = {
  //     country: '',
  //     city: '', // You can use a location API if you want dynamic location info
  //   };

  //   const trafficData = {
  //     ipAddress,
  //     userAgent,
  //     route,
  //     location,
  //   };

  //   // Sending the data to the backend API using POST request
  //   try {
  //     const response = await axios.post('http://localhost:8000/api/log-traffic', trafficData);
  //     console.log('Traffic logged successfully:', response.data);
  //   } catch (error) {
  //     console.error('Error logging traffic:', error);
  //   }
  // };

  
  useEffect(() => {
    let rafId;
  
    // Use requestAnimationFrame to ensure non-blocking update
    const startLoadingTimeout = () => {
      rafId = requestAnimationFrame(() => {
        setTimeout(() => setLoading(false), 400); // 4ms seconds if it's first time
      });
    };
  
    startLoadingTimeout();
  
    return () => {
      cancelAnimationFrame(rafId); // Clean up RAF
    };
  }, []);
  
  // false when user close tabs 
  useEffect(() => {
    const handleBeforeUnload = () => {
      const allowedPaths = ['/', '/galary'];
      if (allowedPaths.includes(location.pathname)) {
        localStorage.setItem('hasVisitedGalary', 'false');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [location.pathname]);


  return (
      <div>
        {!loading ? (
          <div >
            <Navbar theme={theme} darkMode={darkMode}/>
            <Home darkMode={darkMode}/>
            <About darkMode={darkMode}/>
            <Services darkMode={darkMode}/>

                  {/* commented projects due to NDA security reason */}
            {devProjects &&<Projects darkMode={darkMode}/>}

            <Contact darkMode={darkMode}/>
             {/* Chat Button */}
            <ChatButton chatOpen={chatOpen} setChatOpen={setChatOpen}/>
            {chatOpen && <ChatBot darkMode={darkMode} chatOpen={chatOpen} setChatOpen={setChatOpen}/>}
          </div>

        ) : (
          <LoadingScreen />
          )}
      </div>

  );
}

export default All;
